import Vue from 'vue'
import Router from 'vue-router'
import Clause from './../pages/Clause'
import OneKeyTrans from './../pages/OneKeyTrans'
import Complain from './../pages/Complain'
import WebPageTrans from "./../pages/WebPageTrans";
import Wap from './../pages/Wap'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'webPageTrans',
      component: WebPageTrans
    },
    {
      path: '/clause',
      name: 'clause',
      component: Clause
    },
    {
      path: '/oneKeyTrans',
      name: 'oneKeyTrans',
      component: OneKeyTrans
    },
    {
      path: '/complain',
      name: 'complain',
      component: Complain
    },
    {
      path: '/wap',
      name: 'wap',
      component: Wap
    }
  ]
})